<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm_title"><a id="page_vi"></a>Acknowledgements</h2>
<p class="noindentt">I owe a debt of gratitude to the following:</p>
<p class="noindentt">Lord Sandhurst, for access to his father’s records of the Radio Security Service and Special Communications Unit 1; Jürgen Rohwer; Donald Shirreff; Ralph Erskine; Roy Rodwell of the Marconi Company; Barbara Tuchman; David Kahn; Pat Hawker; Gerry Openshaw; all the former members of RSS who kindly gave their help; and the Radio Society of Great Britain.</p>
<p class="noindentt">The staff of the Public Records Office in Kew; the British Museum; the Imperial War Museum; Churchill College, Cambridge; King’s College, London; the GPO Archives, London; the Royal Signals Museum, Blandford; the Intelligence Corps Museum, Ashford.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgements.vue?08db38f2